'use client';

import React, { ReactNode } from 'react';
import AccordionTitle from './AccordionTitle';
import AccordionContent from './AccordionContent';
import AccordionSeparator from './AccordionSeparator';
import { AccordionProvider } from './AccordionProvider';

export type AccordionProps = {
  children: ReactNode;
  defaultOpen?: boolean;
};

function AccordionComponent({ children, defaultOpen = false }: AccordionProps) {
  return <AccordionProvider deafultOpen={defaultOpen}>{children}</AccordionProvider>;
}

const Accordion = Object.assign(AccordionComponent, {
  Title: AccordionTitle,
  Content: AccordionContent,
  Separator: AccordionSeparator,
});

export default Accordion;
